import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, Mail } from "lucide-react";
import { WHATSAPP_URL, MAIL_URL } from "../../lib/contact";

export default function CtaFinal() {
  return (
    <section
      id="cta-final"
      data-testid="cta-final-section"
      className="relative bg-brand-navy text-white py-24 lg:py-28 overflow-hidden"
    >
      {/* Gold geometric pattern overlay */}
      <div aria-hidden className="absolute inset-0 bg-blueprint-dark bg-grid-40 opacity-60" />
      <svg
        aria-hidden
        className="absolute -right-20 -top-20 w-[420px] h-[420px] text-brand-gold/15"
        viewBox="0 0 400 400" fill="none" stroke="currentColor" strokeWidth="1"
      >
        <circle cx="200" cy="200" r="180" />
        <circle cx="200" cy="200" r="120" strokeDasharray="3 6" />
        <circle cx="200" cy="200" r="60" />
      </svg>
      <svg
        aria-hidden
        className="absolute -left-24 -bottom-24 w-[360px] h-[360px] text-brand-gold/10"
        viewBox="0 0 400 400" fill="none" stroke="currentColor" strokeWidth="1"
      >
        <polygon points="200,20 380,200 200,380 20,200" strokeDasharray="4 6" />
      </svg>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center"
      >
        <div className="flex justify-center items-center gap-3">
          <span className="h-px w-10 bg-brand-gold" />
          <span className="label-overline">Empieza Hoy</span>
          <span className="h-px w-10 bg-brand-gold" />
        </div>

        <h2 className="mt-6 font-playfair text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight text-balance">
          ¿Necesitas un <span className="italic text-brand-gold">avalúo</span>, peritaje o servicio de DRO en Puebla?
        </h2>

        <p className="mt-6 font-inter text-lg text-white/70 leading-relaxed max-w-2xl mx-auto">
          Contáctanos hoy y recibe una cotización personalizada en menos de 24 horas.
          Más de 40 años de experiencia respaldan cada servicio.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-final-whatsapp"
            className="inline-flex items-center justify-center gap-2.5 rounded-sm bg-brand-gold px-7 py-4 font-mont text-xs font-semibold uppercase tracking-[0.16em] text-brand-navy hover:bg-white hover:-translate-y-0.5 transition-all duration-300 shadow-[0_18px_44px_-16px_rgba(201,168,76,0.5)]"
          >
            <MessageCircle size={18} strokeWidth={2} />
            Escríbenos por WhatsApp
          </a>
          <a
            href={MAIL_URL}
            data-testid="cta-final-email"
            className="inline-flex items-center justify-center gap-2 rounded-sm border-2 border-white text-white px-7 py-4 font-mont text-xs font-semibold uppercase tracking-[0.16em] hover:bg-white hover:text-brand-navy transition-all duration-300"
          >
            <Mail size={18} strokeWidth={2} />
            Solicitar Cotización por Email
          </a>
        </div>

        <p className="mt-6 font-inter text-xs uppercase tracking-[0.2em] text-white/50">
          Sin compromisos · Respuesta garantizada en menos de 24 horas
        </p>
      </motion.div>
    </section>
  );
}
